import React from 'react'

function SectionContentContainer(props) {
  const { children } = props // eslint-disable-line react/prop-types

  return <div className="ms-3 me-3">{children}</div>
}

export default SectionContentContainer
